import { render, staticRenderFns } from "./userLogList.vue?vue&type=template&id=22b1f38d&scoped=true&"
import script from "./userLogList.vue?vue&type=script&lang=js&"
export * from "./userLogList.vue?vue&type=script&lang=js&"
import style0 from "./userLogList.vue?vue&type=style&index=0&id=22b1f38d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1f38d",
  null
  
)

export default component.exports